import { yupResolver } from '@hookform/resolvers/yup'
import { Notifications, ChevronRight } from '@mui/icons-material'
import classNames from 'classnames'
import { NoticeSettingsForm } from 'feature/user/components/NoticeSettingsForm/NoticeSettingsForm'
import { noticeFormDefaultValues } from 'feature/user/helpers/editNoticeFormObjects'
import { useGetUserNoticeDataQuery } from 'feature/user/redux/user.api'
import { UserNotice } from 'feature/user/types'
import { useEffect, useMemo } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { Button } from 'ui'
import { LoaderInCentalPosition } from 'widget'
import * as yup from 'yup'

import style from './UserSettingsNotice.module.scss'

const schema = yup.object().shape({
  isSmsOn: yup.boolean(),
  isEmailOn: yup.boolean(),
  isWhatsAppOn: yup.boolean(),
  isTelegramOn: yup.boolean(),
  agreeSubscribeAdvertising: yup.boolean(),
})

export function UserSettingsNotice() {
  const { isLoading, data, isSuccess } = useGetUserNoticeDataQuery()

  const formMethods = useForm<UserNotice>({
    defaultValues: useMemo(() => noticeFormDefaultValues(data), [data]),
    // @ts-ignore
    resolver: yupResolver(schema),
  })

  useEffect(() => {
    if (data) {
      formMethods.reset(noticeFormDefaultValues(data))
    }
  }, [data, formMethods])

  return (
    <section className={style.settingEmailPage}>
      <div className={style.header}>
        <Button
          // @ts-ignore
          to='/settings'
          variant='text'
          className={style.backButton}
          color='primary'
          data-testid='notice-back-btn'
          startIcon={
            <ChevronRight
              color='primary'
              className={classNames('rotate180', style.chevronRight)}
            />
          }
        >
          Назад
        </Button>

        <div className={style.title}>
          <Notifications color='primary' />
          <span className='h1'>уведомления</span>
        </div>
      </div>

      {isLoading && <LoaderInCentalPosition className={style.loader} />}

      {!isLoading && isSuccess && (
        <FormProvider {...formMethods}>
          <NoticeSettingsForm />
        </FormProvider>
      )}
    </section>
  )
}
